<script>
export default {
    name: "Panel",
    props: ['bids', 'deal'],
    data() {
        return {
            showFile: this.deal.status !== 'auction',
            disabledClass: 'whitespace-nowrap border-b-2 py-6 text-sm font-medium border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-800',
            enabledClass: 'border-indigo-600 text-indigo-600 whitespace-nowrap border-b-2 py-6 text-sm font-medium'
        }
    },
    methods: {
        toggleFile(state) {
            this.showFile = state;
        }
    }
}
</script>

<template>
    <div>


        <div class="border-b border-gray-200 mb-2">
            <div class="-mb-px flex space-x-8" aria-orientation="horizontal" role="tablist">
                <!-- Selected: "border-indigo-600 text-indigo-600", Not Selected: "border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-800" -->
                <button id="tab-productlist" v-if="deal.contains_xlsx" v-on:click="toggleFile(true)"
                        :class="showFile ? enabledClass : disabledClass"
                        aria-controls="tab-panel-productlist" role="tab" type="button"><i
                    class="fa-solid fa-file-excel pr-2"></i> Product List
                </button>
                <button id="tab-bidhistory" v-if="deal.status === 'auction' && bids.length > 0" v-on:click="toggleFile(false)"
                        :class="!showFile ? enabledClass : disabledClass"
                        aria-controls="tab-panel-bidhistory" role="tab" type="button"><i
                    class="fa-solid fa-gavel pr-2"></i>Your Bid History
                </button>
            </div>
        </div>

        <!-- 'Product List' panel, show/hide based on tab state -->
        <div v-if="showFile && deal.contains_xlsx" id="tab-panel-productlist" :class="'pt-4' &&  !showFile ? 'hidden' : ''" aria-labelledby="tab-productlist"
             role="tabpanel"
             tabindex="0">
            <h3 class="sr-only">Product List</h3>

            <a :href="route('deal.show.file', deal)">
                <button class="fw-btn fw-btn-green w-full my-2"
                        style="outline: none;"><i class="fas fa-download px-2"></i> Download Product List
                </button>
            </a>

            <div class="flex space-x-4 text-sm text-gray-500">



                <iframe
                    :data-src="'https://view.officeapps.live.com/op/embed.aspx?src=' + route('deal.show.file', deal)"
                    class="auction-detail__preview-excel" width="100%" height="556px"
                    frameborder="0"
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + route('deal.show.file', deal)"></iframe>
            </div>
        </div>
        <div v-if="!showFile && deal.status === 'auction'">
            <div v-if="bids.length > 0" id="tab-panel-bidhistory" :class="'pt-4' &&  showFile ? 'hidden' : ''" aria-labelledby="tab-bidhistory" role="tabpanel" tabindex="0">
                <h3 class="sr-only">Your Bid</h3>
            <bids :bids="bids" :currency="deal.currency"></bids>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
